<template>
  <!--absolute -> skriva scrollbar i omogućuje prikaz menija skrolanjem stranice
  temporary-->
  <v-navigation-drawer id="app-drawer"
                       height="100%"
                       v-model="inputValue"
                       app
                       dark
                       persistent
                       mobile-break-point="1280"
                       width="330">
    <v-img :src="image"
           :gradient="sidebarOverlayGradiant"
           height="100%">
        <v-layout class="fill-height"
                  tag="v-list"
                  column>

            <v-list-tile avatar>
                <v-list-tile-avatar color="white">
                    <v-img :src="avatar_logo"
                           height="64"
                           contain
                           position="0.5 3.5"
                           class="user-logo" />
                </v-list-tile-avatar>
                <v-list-tile-title class="title pl-1"> {{currentUser.FullName}} </v-list-tile-title>

                <v-btn v-if="responsive || !responsive"
                       class=" v-btn--simple"
                       dark
                       icon
                       @click.stop="onClickBtn">
                    <v-icon>mdi-view-list</v-icon>
                </v-btn>
            </v-list-tile>

            <v-divider></v-divider>
            <v-list-tile v-for="(link, i) in links"
                         :key="i"
                         :to="link.to"
                         :active-class="color"
                         avatar
                         class="v-list-item">
                <v-list-tile-action>
                    <v-icon>{{ link.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title v-text="$t(link.text)" />
            </v-list-tile>

            <v-divider></v-divider>
            <label style="text-align:left">&nbsp; {{ $tc('menu_education', 2)}} </label>
            <v-list-tile v-for="(link, i) in links_education"
                         :key="i + '1'"
                         :to="link.to"
                         :active-class="color"
                         avatar
                         class="v-list-item">
                <v-list-tile-action>
                    <v-icon>{{ link.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title v-text="$t(link.text)" />
            </v-list-tile>

            <v-divider></v-divider>
            <v-list-tile v-for="(link, i) in links_ostali"
                         :key="i + '2'"
                         :active-class="color"
                         avatar
                         class="v-list-item smanji-razmak">
                <v-list-tile-action>
                    <v-icon>{{ link.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title @click="outerLink(link.to)" v-text="$t(link.text)" />
            </v-list-tile>

            <v-divider style="margin-top:5px"></v-divider>

            <template>
              <div class="image-container">
                <div>
                  <img src="/assets/images/icons/google-play-badge.png"
                       style="width: 140px;"
                       alt="Google Play Store"
                       @click="outerLink(links_mob_apps[0].to)" />
                </div>
                <div>
                  <img src="/assets/images/icons/apple-store-badge.png"
                       style="height: 38px; width: 140px;"
                       alt="Apple App Store"
                       @click="outerLink(links_mob_apps[1].to)" />
                </div>
              </div>
              <div class="text-center">
                <img alt="Next Generation EU logo" src="/assets/images/logos/NextGenEU_logo_h.png" style="height: 45px; width: auto;" />
              </div>
            </template>

            <v-list-tile disabled
                         active-class="primary"
                         class="v-list-item v-list__tile--buy"
                         to="/upgrade">

            </v-list-tile>
            <div class="text-center">
                <v-btn rounded color="transparent" class="ma-2 flag-btn" v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)">
                    <v-img :src="getImage(entry.flag)"></v-img>
                    <!--<flag :iso="entry.flag" v-bind:squared=false />-->
                    <!--{{entry.title}}-->
                </v-btn>
            </div>
        </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>

    import { i18n } from '../../../../plugins/i18n';
    import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
    //  const { mapState, mapGetters, mapActions, mapMutations } = createNamespacedHelpers('app');


    export default {
        data: function () {
            return {
                //logo: '/assets/images/icons/female_icon.png',//'./img/vuetifylogo.png',
                links: [
                    {
                        to: '/Portal/Security/PasswordChange',
                        icon: 'mdi-account-convert',
                        text: 'menu_password_change'
                    },
                    {
                        to: '/Portal/Guides',
                        icon: 'mdi-book',
                        text: 'menu_guides'
                    }
                ],
                links_education: [
                    {
                        to: '/',
                        icon: 'mdi-calendar',
                        text: 'menu_my_schedule'
                    },
                    {
                        to: '/Portal/Education/MyEducation',
                        icon: 'mdi-account-details',
                        text: 'menu_my_education'
                    },
                    {
                        to: '/Portal/ExamRegister',
                        icon: 'mdi-clipboard-outline',
                        text: 'menu_exam_register'
                    },
                    {
                        to: '/Portal/ExamUnregister',
                        icon: 'mdi-clipboard-alert',
                        text: 'menu_exam_unregister'
                    },
                    {
                        to: '/Portal/Docs/Download',
                        icon: 'mdi-briefcase-download',
                        text: 'menu_seminar_task_download'
                    },
                    {
                        to: '/Portal/Seminar/Upload',
                        icon: 'mdi-briefcase-upload',
                        text: 'menu_seminar_task_upload'
                    },
                    {
                        to: '/Portal/Exams/ExamResults',
                        icon: 'mdi-clipboard-check',
                        text: 'menu_presence_exam_results'
                    },
                    {
                        to: '/Portal/Education/Deadline',
                        icon: 'mdi-clock-alert',
                        text: 'menu_education_deadline'
                    },
                    {
                        to: '/Portal/Education/MyDigitalCertificate',
                        icon: 'mdi-certificate',
                        text: 'menu_digital_cerficates'
                    }
                ],
                links_ostali: [
                    {
                        to: 'https://upitnik.algebra.hr/anketa/',
                        icon: 'mdi-poll',
                        text: 'menu_surveys'
                    },
                    {
                        to: 'https://www.algebra.hr/cjelozivotno-obrazovanje/zahtjev-za-izdavanje-uvjerenja/',
                        icon: 'mdi-file-document-box-multiple',
                        text: 'menu_certificate_claim'
                    },
                    {
                        to: 'https://www.algebra.hr/naslovnica/kontakt/',
                        icon: 'mdi-contacts',
                        text: 'common.contact'
                    }
                ],
                links_mob_apps: [
                    {
                        to: 'https://play.google.com/store/apps/details?id=algebra.cjelozivotno.obrazovanje'
                    },
                    {
                        to: 'https://apps.apple.com/us/app/algebra-u%C4%8Dili%C5%A1te/id6471991958?platform=iphone'
                    }
                ],
                responsive: false
            }

        },
        computed: {
            ...mapState('app', ['image', 'color', 'currentUser', 'languages', 'drawer']),
            inputValue: {
                get() {
                    return this.drawer
                },
                set(val) {
                    this.setDrawer(val)
                }
            },
            items() {
                return this.$t('Layout.View.items')
            },
            sidebarOverlayGradiant() {
                return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor}`
            },
            avatar_logo: {
                get: function () {
                    if (this.currentUser.Spol == 'M') {
                        return '/assets/images/icons/male_icon.png';
                    } else {
                        return '/assets/images/icons/female_icon.png';
                    }
                }
            }
        },
        mounted() {
            this.onResponsiveInverted()
            window.addEventListener('resize', this.onResponsiveInverted)

            if (localStorage.getItem('odabrani_jezik_aplikacije') !== null) {
                this.changeLocale(localStorage.getItem('odabrani_jezik_aplikacije'));
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResponsiveInverted)
        },
        methods: {
            ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
            changeLocale(locale) {
                localStorage.setItem('odabrani_jezik_aplikacije', locale);
                i18n.locale = locale;
            },

            onResponsiveInverted() {
                // 991 je defaultno, ali zapravo to bi ako se ne varam trebalo biti isto kao mobile-break-point parametar
                if (window.innerWidth < 991) {
                    this.responsive = true
                } else {
                    this.responsive = false
                }
            },

            // Kopirao iz Toolbar.vue (tamo je gumbić za prikaz/skrivanje menija, a ja isto hoću i ovdje)
            onClickBtn() {
                //this.setDrawer(!this.$store.state.app.drawer)
                this.inputValue = !this.inputValue;
            },

            outerLink(link) {
                window.open(link, '_blank');
            },

            getImage(img) {
                switch (img) {
                    case 'hr': return '/assets/images/icons/flag_croatia.png';
                    case 'us': return '/assets/images/icons/flag_united-kingdom.png';
                    default: return ''
                }
            }
        }
    }
</script>

<style lang="scss">
    #app-drawer {
        .v-list__tile {
            border-radius: 4px;

            &--buy {
                margin-top: auto;
                margin-bottom: 17px;
            }
        }

        .v-image__image--contain {
            top: 9px;
            height: 60%;
        }

        .search-input {
            margin-bottom: 30px !important;
            padding-left: 15px;
            padding-right: 15px;
        }

        div.v-responsive.v-image > div.v-responsive__content {
            overflow-y: auto;
        }
    }

    .smanji-razmak {
        height: 35px !important;
    }

    .image-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
    }

</style>



// WEBPACK FOOTER //
// VueSrc/Common/Components/materialcomponents/components/core/Drawer.vue